<template lang="pug">
Page.repairs
    .repairs__top(
        slot="header"
    )
        h1.repairs__title
            | Каталог ремонтов

        .repairs__subheader
            SvInput.repairs__search(
                v-model="search"
                placeholder="Введите название ЖК"
                color="gray"
                size="large"
            )

            SvButton.repairs__add(
                view="big"
                text="Добавить"
                :prependIcon=`{
                    icon: 'plus',
                    width: 17,
                    height: 17,
                    fillDefault: '#fff',
                    fillHover: '#fff'
                }`
                @click="transfer('new')"
            )

    SvTable.repairs__table(
        :headers="headers"
        :body="getList"
        @transfer="(e) => transfer(e.id)"
    )
</template>

<script>
import { http } from '@/helpers/http';
import { mapGetters } from 'vuex';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTable from '@/components/uikit/SvTable.vue';

export default {
  name: 'Repairs',

  beforeMount() {
    this.$store.dispatch('repair/getList');

  },

  data() {
    return {
      headers: [
        {
          title: 'Название',
          path: 'title',
          width: '20%',
        },
        {
          title: 'Название объектов',
          path: 'residentials_formatted',
          width: '40%',
        },
        {
          title: 'Дата изменения',
          path: 'updated_at',
          width: '20%',
        },
        {
          title: 'Аквтивность',
          path: 'is_active',
          width: '20%',
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      getList: 'repair/getList',
    }),

    search: {
      get() {
        return this.$store.state.repair.search;
      },

      set(search) {
        this.$store.commit('repair/setSearch', search);
      },
    },
  },

  methods: {
    transfer(id) {
      this.$router.push({
        name: 'repair-edit',
        params: {
          id,
        },
      });
    },
  },

  mounted() {
  },

  components: {
    Page,
    SvInput,
    SvButton,
    SvTable,
  },
};
</script>

<style lang="scss">
.repairs__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.repairs__subheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.repairs__search {
    width: 47%;
    min-width: 280px;
}

.repairs__table {
    margin-top: 30px;
}
.sv-table__cell {
  overflow: hidden;
}

.sv-table__row .sv-table__cell:nth-child(2) {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 44px;
    padding-top: 10px;
    padding-right: 15px;
    align-items: flex-start;
    justify-content: center;
}
</style>
